export default __webpack_public_path__ + "static/media/Pross-BG.45503f1b.webp";